import { render, staticRenderFns } from "./basicEnrichment.vue?vue&type=template&id=e028f842&scoped=true"
import script from "./basicEnrichment.vue?vue&type=script&lang=js"
export * from "./basicEnrichment.vue?vue&type=script&lang=js"
import style0 from "./basicEnrichment.vue?vue&type=style&index=0&id=e028f842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e028f842",
  null
  
)

export default component.exports